module.exports = __webpack_public_path__ + "img/avater.1835cefe.jpg";